import { useState } from 'react'
import { CONFIG } from '../../../../api/config'
import ButtonComponent from '../../button.component'
import { LoginOverlay } from '../login.modal.component/styled'
import * as styled from './styled'

export const ConfirmModalComponent = ({
	onClose,
	onBack,
}: {
	onClose: () => void
	onBack: () => void
}) => {
	const [dontShowAgain, setDontShowAgain] = useState(false)

	const handleConfirm = () => {
		if (dontShowAgain) {
			localStorage.setItem('skipConfirmCabinet', 'true')
		}
		window.open(CONFIG.SMART_CITY, '_blank', 'noopener,noreferrer')
		onClose()
	}

	return (
		<>
			<LoginOverlay
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				onClick={onClose}
			/>
			<styled.ConfirmCenterContainer
				initial={{ opacity: 0, scale: 0.8, x: '-50%', y: '-40%' }}
				animate={{ opacity: 1, scale: 1, x: '-50%', y: '-50%' }}
				exit={{ opacity: 0, scale: 0.8, x: '-50%', y: '-40%' }}
				transition={{ type: 'spring', damping: 25, stiffness: 300 }}
			>
				<styled.ConfirmWrapper>
					<styled.CloseBtn onClick={onClose}>✕</styled.CloseBtn>

					<styled.ConfirmTitle>Підтвердження переходу</styled.ConfirmTitle>

					<styled.ConfirmText>
						Ви будете перенаправлені до підсистеми «Кабінет Мешканця» вебпорталу
						«Цифрове Запоріжжя» для подальшої роботи з електронними сервісами та
						зверненнями.
					</styled.ConfirmText>

					<styled.CheckboxContainer as='label' htmlFor='confirm-check'>
						<input
							type='checkbox'
							id='confirm-check'
							style={{ display: 'none' }}
							checked={dontShowAgain}
							onChange={e => setDontShowAgain(e.target.checked)}
						/>
						<styled.CheckboxCustom>
							{/* Галочка появится здесь через ::after */}
						</styled.CheckboxCustom>
						<styled.CheckboxText>
							Не відображати це повідомлення повторно
						</styled.CheckboxText>
					</styled.CheckboxContainer>

					<styled.ConfirmModalActions>
						<ButtonComponent
							position='bottom-right'
							text='Підтвердити'
							onClick={handleConfirm}
						/>
						<ButtonComponent
							text='Скасувати'
							position='top-right'
							variant='outline'
							onClick={onBack} 
						/>
					</styled.ConfirmModalActions>
				</styled.ConfirmWrapper>
			</styled.ConfirmCenterContainer>
		</>
	)
}
